import OverlayNotificationModal from 'components/OverlayNotificationModal';
import { UserContext } from 'contexts/user/UserContext';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import menuItems from '../constants/mainMenu';
import Sidebar from '../containers/navs/Sidebar';
import TopNav from '../containers/navs/Topnav';
import { useMenu } from 'contexts/MenuContextUtils';

const AppLayoutNoFooter = ({ children }) => {
  const { containerClassnames } = useMenu();
  const { currentUser } = useContext(UserContext);
  const history = useHistory();

  return (
    <div id="app-container" className={containerClassnames}>
      <OverlayNotificationModal />
      <TopNav history={history} />
      <Sidebar name="Main" menuItems={menuItems} currentUser={currentUser} />
      <main>
        <div className="container-fluid">
          {children}
        </div>
      </main>
    </div>
  );
};
export default AppLayoutNoFooter;
